import React, { Component } from "react";
import { Button, Checkbox, Form, Icon, Modal, Select } from "semantic-ui-react";
import { riceMill, multiFunction, longTail } from "assets/data/modelOption";
import { UserContext } from "context/userProvider";
import "scss/components/modals/customers/newCustomer.scss";
import Swal from "sweetalert2";
import { modelOption } from "assets/data/deviceModel";

export default class NewCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      passwd: null,
      name: null,
      lineId: null,
      phoneNo: null,
      phoneNoOption: null,
      addr: null,
      deviceType: [
        {
          type: "เครื่องสีข้าว และเครื่องคัดแยกเมล็ดพันธุ์ข้าว",
          enable: false,
          model: "",
          description: "",
        },
        {
          type: "เครื่องจักรกลทางการเกษตร(Model)",
          enable: false,
          model: "",
          description: "",
        },
        {
          type: "หางเรือ",
          enable: false,
          model: "",
          description: "",
        },
        {
          type: "อิ่นๆ",
          enable: false,
          model: "",
          description: "",
        },
      ],
    };
  }

  alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      confirmButton: "OK",
    }).then((res) => {
      // if (res.isConfirmed) {
      //   return this.props.isClose();
      // }
    });
  };

  onAddCustomer = async () => {
    if (
      this.state.id === null ||
      this.state.passwd === null ||
      this.state.name === null ||
      this.state.phoneNo === null ||
      this.state.addr === null ||
      this.state.deviceTypes === null
    )
      return this.alertDialog("Warning!", "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน", "warning");

    let deviceOptions = this.state.deviceType.filter(
      (device) => device.enable === true
    );

    const data = {
      id: this.state.id,
      passwd: this.state.passwd,
      name: this.state.name,
      email: this.state.lineId,
      phoneNo: this.state.phoneNo,
      phoneNoOptional: this.state.phoneNoOption,
      addr: this.state.addr,
      deviceTypes: deviceOptions,
      role: "user",
      team_id: 1,
    };
    console.log("datas",data);

    let result = await this.context.userRegister(data);
    if (result != null) {
      if (result?.result === "success") {
        await this.context.getCustomers({ team_id: -1, role: "" });
        return this.alertDialog("Success!","เพิ่มลูกค้าสำเร็จ",result?.result);
      } else return this.alertDialog("Error!", "เพิ่มลูกค้าไม่สำเร็จ", "error");
    } else return this.alertDialog("Error!", "เพิ่มลูกค้าไม่สำเร็จ", "error");
  };

  updateDeviceType = (e, idx) => {
    const { deviceType } = this.state;

    // TOGGLE ENABLE STATUS
    deviceType[idx]["enable"] = !deviceType[idx]["enable"];
    this.setState({ deviceType: deviceType });
  };

  createCustomerDetail = () => {
    const usernameRegex = /^([a-zA-Z0-9])+$/;
    const { deviceType } = this.state;
    const riceMillOptions = riceMill.map((device) => ({
      key: device,
      value: device,
      text: device,
    }));
    const multiFunctionOptions = multiFunction.map((device) => ({
      key: device,
      value: device,
      text: device,
    }));
    const longTailOptions = longTail.map((device) => ({
      key: device,
      value: device,
      text: device,
    }));
    const modelOptions = modelOption.map((model) => ({
      key: model,
      value: model,
      text: model,
    }));
    return (
      <table>
        <tbody>
          <tr>
            <td>ชื่อบัญชีผู้ใช้งาน<span style={{ color: "#ff0000" }}>*</span></td>
            <td>
              <Form.Input
                type="text"
                placeholder="ชื่อบัญชีผู้ใช้งาน (ห้ามมีช่องว่าง)"
                onChange={(e) => {
                  if (e.target.value === "" || usernameRegex.test(e.target.value)
                  ) {
                    this.setState({ id: e.target.value});
                  }
                }}
              ></Form.Input>
            </td>
          </tr>
          <tr>
            <td>รหัสผ่าน<span style={{ color: "#ff0000" }}>*</span></td>
            <td>
              <Form.Input
                type="password"
                placeholder="รหัสผ่าน"
                onChange={(e) => this.setState({ passwd: e.target.value })}
              ></Form.Input>
            </td>
          </tr>
          <tr>
            <td>
              ชื่อ-นามสกุล<span style={{ color: "#ff0000" }}>*</span>
            </td>
            <td>
              <Form.Input
                type="text"
                placeholder="ชื่อ-นามสกุล"
                onChange={(e) => this.setState({ name: e.target.value })}
              ></Form.Input>
            </td>
          </tr>
          <tr>
            <td>
              Line ID
            </td>
            <td>
              <Form.Input
                type="text"
                placeholder="Line ID"
                onChange={(e) => this.setState({ lineId: e.target.value })}
              ></Form.Input>
            </td>
          </tr>
          <tr>
            <td>
              เบอร์โทร<span style={{ color: "#ff0000" }}>*</span>
            </td>
            <td>
              <Form.Input
                type="text"
                placeholder="เบอร์โทร"
                onChange={(e) => this.setState({ phoneNo: e.target.value })}
              ></Form.Input>
            </td>
          </tr>
          <tr>
            <td>เบอร์โทร (เพิ่มเติม)</td>
            <td>
              <Form.Input
                type="text"
                placeholder="เบอร์โทร (เพิ่มเติม)"
                onChange={(e) =>
                  this.setState({ phoneNoOption: e.target.value })
                }
              ></Form.Input>
            </td>
          </tr>
          <tr>
            <td>
              ที่อยู่<span style={{ color: "#ff0000" }}>*</span>
            </td>
            <td>
              <Form>
                <Form.TextArea
                  type="text"
                  placeholder="ที่อยู่"
                  onChange={(e) => 
                    this.setState({ addr: e.target.value })}
                ></Form.TextArea>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              ประเภทเครื่องจักร<span style={{ color: "#ff0000" }}>*</span>
            </td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>เครื่องสีข้าว,เครื่องคัดแยกเมล็ดพันธุ์</label>}
                checked={deviceType[0].enable === true}
                onChange={(e) => this.updateDeviceType(e, 0)}
              />
              {deviceType[0].enable === true && (
                <>
                  <Form>
                    <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นเครื่องสีข้าว,เครื่องคัดแยกเมล็ดพันธุ์"
                      search
                      onChange={(e, { value }) => {
                        deviceType[0]["model"] = value;
                      }}

                    />
                    <Form.TextArea
                      placeholder="Serial Number, วันที่ซื้อสินค้า, ช่องทางการซื้อสินค้า และรายละเอียดอื่นๆ (ถ้ามี)"
                      onChange={(e) => {
                        deviceType[0]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>เครื่องจักรกลทางการเกษตร(Model)</label>}
                checked={deviceType[1].enable === true}
                onChange={(e) => this.updateDeviceType(e, 1)}
              />
              {deviceType[1].enable === true && (
                <>
                  <Form>
                    <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นเครื่องจักรกลทางการเกษตร(Model)"
                      search
                      onChange={(e, { value }) => {
                        deviceType[1]["model"] = value;
                      }}
                    />
                    <Form.TextArea
                      placeholder="Serial Number, วันที่ซื้อสินค้า, ช่องทางการซื้อสินค้า และรายละเอียดอื่นๆ (ถ้ามี)"
                      onChange={(e) => {
                        deviceType[1]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>หางเรือ</label>}
                checked={deviceType[2].enable === true}
                onChange={(e) => this.updateDeviceType(e, 2)}
              />
              {deviceType[2].enable === true && (
                <>
                  <Form>
                    <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นหางเรือ"
                      search
                      onChange={(e, { value }) => {
                        deviceType[2]["model"] = value;
                      }}
                    />
                    <Form.TextArea
                      placeholder="Serial Number, วันที่ซื้อสินค้า, ช่องทางการซื้อสินค้า และรายละเอียดอื่นๆ (ถ้ามี)"
                      onChange={(e) => {
                        deviceType[2]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>อิ่นๆ</label>}
                checked={deviceType[3].enable === true}
                onChange={(e) => this.updateDeviceType(e, 3)}
              />
              {deviceType[3].enable === true && (
                <>
                  <Form>
                    <Form.TextArea
                      placeholder="Serial Number, วันที่ซื้อสินค้า, ช่องทางการซื้อสินค้า และรายละเอียดอื่นๆ (ถ้ามี)"
                      onChange={(e) => {
                        deviceType[3]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    return (
      <Modal
        closeIcon
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Header>
          <Icon name="user plus" />
          &ensp;เพิ่มลูกค้าใหม่
        </Modal.Header>
        <Modal.Content scrolling>{this.createCustomerDetail()}</Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={() => this.props.isClose()}>
            ยกเลิก
          </Button>
          <Button color="twitter" onClick={() => this.onAddCustomer()}>
            บันทึก
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

NewCustomer.contextType = UserContext;
